import React, { Fragment, useState, useRef } from "react";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import "../AdminPages.css";

const UpdateGoalsForSchools = () => {
  const [schoolName, setSchoolName] = useState();
  const [showSchoolNameContainer, setShowSchoolNameContainer] = useState(false);
  const [schoolNameList, setSchoolNameList] = useState();
  const schoolNameRef = useRef();
  const timeoutRef = useRef();
  const [schoolNameLoading, setSchoolNameLoading] = useState(false);
  const [schoolId, setSchoolId] = useState();
  const [loading, setLoading] = useState(false);
  const [oldGoalData, setOldGoalData] = useState();
  const [newGoalData, setNewGoalData] = useState();
  const [oldGoalId, setOldGoalId] = useState();
  const [newGoalId, setNewGoalId] = useState();

  const getSchoolsList = (value) => {
    setSchoolNameLoading(true);
    GetAdminService.getSchoolsList(value)
      .then((data) => {
        setSchoolNameList(data?.data?.school);
        setSchoolNameLoading(false);
        setShowSchoolNameContainer(true);
      })
      .catch(() => {
        setSchoolNameLoading(false);
      });
  };

  const getGoalData = (id) => {
    setLoading(true);
    let obj = { school_id: id };
    GetAdminService.goalBySchool(obj)
      .then((data) => {
        setOldGoalData(data.data.goal_name);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });

    setLoading(true);
    GetAdminService.goalPublish(id)
      .then((data) => {
        setNewGoalData(data.data.objects);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const updateSchoolGoal = () => {
    let obj = {
      school_id: schoolId,
    };
    if (parseInt(oldGoalId)) obj.old_goal_id = parseInt(oldGoalId);
    if (parseInt(newGoalId)) obj.new_goal_id = parseInt(newGoalId);
    setLoading(true);
    GetAdminService.updateSchoolGoal(obj)
      .then((data) => {
        setLoading(false);
        if (data.data.status === "success")
          swal({
            text: "Goals for schools updated successfully!",
            icon: "success",
            buttons: {
              confirm: true,
            },
            closeOnClickOutside: false,
          });
        setSchoolName("");
        setSchoolId();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleSchoolName = () => {
    clearTimeout(timeoutRef.current);
    setSchoolName(schoolNameRef.current.value);
    if (!schoolNameRef.current.value) {
      setShowSchoolNameContainer(false);
      setSchoolNameList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getSchoolsList(schoolNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedSchoolName = (item) => {
    setSchoolNameList([item]);
    setShowSchoolNameContainer(false);
    setSchoolName(item.name);
    setSchoolId(item?.id);
    getGoalData(item?.id);
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-import-container">
            <div className="admin-students-page-header">
              <h2>Update Goals For Schools</h2>
            </div>

            <div className="admin-students-school-selector">
              <label>Select School</label>
              <div className="school-input-wrapper">
                <input
                  ref={schoolNameRef}
                  type="text"
                  placeholder="Type to search school name..."
                  value={schoolName}
                  onChange={handleSchoolName}
                  autoComplete="off"
                />
                {showSchoolNameContainer && (
                  <ul className="school-dropdown">
                    {schoolNameLoading && <CustomLoader />}
                    {schoolNameList?.length > 0 &&
                      schoolNameList.map((item, index) => (
                        <li
                          onClick={() => handleSelectedSchoolName(item)}
                          key={index}
                        >
                          {item.name}
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </div>

            {schoolId && (
              <div className="admin-page-section">
                {loading ? (
                  <CustomLoader />
                ) : (
                  <div className="admin-page-card">
                    <div className="admin-page-form-row">
                      <label>Select Old Goal</label>
                      <select
                        name="ack"
                        className="admin-page-select"
                        value={oldGoalId}
                        onChange={(e) => setOldGoalId(e.target.value)}
                      >
                        <option value="">--Select Goal--</option>
                        {oldGoalData?.map((item, index) => (
                          <option key={index} value={item?.id}>
                            {item.goal_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="admin-page-form-row">
                      <label>Select New Goal</label>
                      <select
                        name="ack"
                        className="admin-page-select"
                        value={newGoalId}
                        onChange={(e) => setNewGoalId(e.target.value)}
                      >
                        <option value="">--Select Goal--</option>
                        {newGoalData?.map((item, index) => (
                          <option key={index} value={item?.goal?.id}>
                            {item?.goal?.goal_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <button
                      className="admin-students-new-btn"
                      onClick={updateSchoolGoal}
                    >
                      <FontAwesomeIcon icon={faSave} />
                      Update Goals
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UpdateGoalsForSchools;
